import './App.css';
import './styles/ftm-landing.css';
import './index.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import CallFab from './components/CallFab';
import HomePageRedesigned from './pages/HomePageRedesigned';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import RefundPolicy from './pages/RefundPolicy';

const DEFAULT_TITLE = 'Family Tree Maker Helps';

const PAGE_TITLES = {
  '/': DEFAULT_TITLE,
  '/privacy-policy': 'Privacy Policy | Family Tree Maker Helps',
  '/terms-and-conditions': 'Terms and Conditions | Family Tree Maker Helps',
  '/refund-policy': 'Refund Policy | Family Tree Maker Helps',
};

function DocumentTitle() {
  const location = useLocation();

  useEffect(() => {
    const title = PAGE_TITLES[location.pathname] || DEFAULT_TITLE;
    document.title = title;
  }, [location.pathname]);

  return null;
}

function AppRoutes() {
  return (
    <>
      <DocumentTitle />
      <Routes>
        <Route path="/" element={<HomePageRedesigned />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <CallFab />
      <AppRoutes />
    </BrowserRouter>
  );
}
